import { VehicleForm, VehicleFuelEntryForm, VehicleMeterReadingEntryForm } from '@/models'
import type { TMachineState } from '@/types/state-types'

export default <TMachineState>{
  machineForm: new VehicleForm(),
  isMachineLoading: false,
  machineFuelEntryForm: new VehicleFuelEntryForm(),
  machineMeterEntryForm: new VehicleMeterReadingEntryForm()
}
